export default (node) => {
  const body = document.querySelector('body');
  const header = node.querySelector('.header');
  const main = document.querySelector('main');
  const headerBar = node.querySelector('[data-header-bar]');
  const headerNav = node.querySelector('[data-header-nav]');
  const template = node.dataset.template;
  const headerLinks = node.querySelectorAll('[data-header-link]');
  const mobileMenuLink = node.querySelector('[data-mobile-menu-link]');
  const mobileMenu = node.querySelector('[data-mobile-menu]');
  const megaMenuWrapper = node.querySelector('[data-megamenus]');
  const megaMenus = node.querySelectorAll('[data-megamenu]');
  const megaMenuOverlay = node.querySelector('[data-megamenu-overlay]');

  let lastScrollY = window.scrollY;

  const handleHeaderBarPosition = () => {
    if (!headerBar) return;

    const currentScrollY = window.scrollY;
    const isScrollingDown = currentScrollY > lastScrollY;

    // Hide header bar by translating the entire header up
    if (isScrollingDown && currentScrollY > 32) {
      header.classList.add('-translate-y-8');
    }
    // Show header bar when scrolling up or at the top
    else if (!isScrollingDown || currentScrollY <= 32) {
      header.classList.remove('-translate-y-8');
    }

    lastScrollY = currentScrollY;
  };

  const handleHeaderTransparency = () => {
    if (window.scrollY > window.innerHeight * 0.5) {
      header.classList.remove('header--transparent');
    } else if (node.dataset.template === 'index') {
      header.classList.add('header--transparent');
    }
  };

  const handleMobileMenuOpen = () => {
    body.classList.add('!overflow-hidden');
    header.classList.add('menu-open');
    mobileMenuLink.classList.add('open');
    mobileMenu.classList.remove('animate-fade-up');
    mobileMenu.classList.remove('hidden');
    mobileMenu.classList.add('animate-fade-down');
  };

  const handleMobileMenuClose = () => {
    body.classList.remove('!overflow-hidden');
    header.classList.remove('menu-open');
    mobileMenuLink.classList.remove('open');
    mobileMenu.classList.add('animate-fade-up');
    mobileMenu.classList.add('hidden');
    mobileMenu.classList.remove('animate-fade-down');
  };

  const handleMenuOpen = (linkTitle) => {
    megaMenus.forEach((megamenu) => {
      megamenu.classList.add('closed');
    });
    let megaMenu = [...megaMenus].filter((megamenu) => {
      return megamenu.dataset.megamenuMenuPoint === linkTitle;
    })[0];
    if (megaMenu) {
      megaMenu.classList.remove('closed');
      body.classList.add('!overflow-hidden');
      header.classList.add('menu-open');
      megaMenuWrapper.classList.add('menu-open');
    } else {
      handleMenuClose();
    }
  };

  const handleMenuClose = () => {
    megaMenus.forEach((megamenu) => {
      megamenu.classList.add('closed');
    });
    body.classList.remove('!overflow-hidden');
    megaMenuWrapper.classList.remove('menu-open');
    setTimeout(() => {
      header.classList.remove('menu-open');
    }, 400);
  };

  const init = () => {
    const isFirstSectionTransparent = main
      .querySelector('.shopify-section')
      ?.classList.contains('transparent-section');

    headerLinks.forEach((headerLink) => {
      headerLink.addEventListener('click', (evt) => {
        evt.preventDefault();
        const linkTitle = headerLink.innerText;
        handleMenuOpen(linkTitle);
      });
      headerLink.addEventListener('mouseenter', () => {
        const linkTitle = headerLink.innerText;
        if (header.classList.contains('menu-open')) {
          handleMenuOpen(linkTitle);
        }
      });
    });

    megaMenuOverlay.addEventListener('click', () => {
      handleMenuClose();
    });

    mobileMenuLink.addEventListener('click', (e) => {
      e.preventDefault();
      if (mobileMenuLink.classList.contains('open')) {
        handleMobileMenuClose();
      } else {
        handleMobileMenuOpen();
      }
    });

    document.addEventListener('scroll', (e) => {
      handleHeaderBarPosition();
    });

    const alwaysSolid = node.dataset.alwaysSolid === 'true';

    if (alwaysSolid || !isFirstSectionTransparent || template !== 'index') {
      header.classList.remove('header--transparent');
      return;
    }

    document.addEventListener('scroll', (e) => {
      handleHeaderTransparency();
    });

    header.addEventListener('mouseenter', () => {
      header.classList.remove('header--transparent');
    });

    header.addEventListener('mouseleave', () => {
      handleHeaderTransparency();
    });
  };

  init();
};
